$(document).ready(function() {

	let ACTION_TO_ADVERTISEMENTS_LISTING = "action-to-advertisements-listing";
	let SELECT_ADVERTISEMENT = "select-advertisement";
	let REASON_REJECT_MODAL = "#reason_reject_modal";
	let SEND_REJECT_REASON = "#send-reject-reason";
	let REASON_REJECT = "#reason-reject";

	let URL_APPROVE_ADVERTISEMENTS = "/approve_advertisements";
	let URL_REJECT_ADVERTISEMENTS = "/reject_advertisements";

	function selectedAdvertisementIds() {
		return $('.' + SELECT_ADVERTISEMENT + ':checkbox:checked').map(function() {
			return this.value;
		}).get().join(",");
	}

	$(document).on('click', '.' + ACTION_TO_ADVERTISEMENTS_LISTING, function() {
		let advertisements_ids = selectedAdvertisementIds();
		if (advertisements_ids === "") {
			alert("Selecione ao menos 1 anúncio");
			return;
		}
		if (this.id === "approve-advertisements") {
			approveSelectedAdvertisements(advertisements_ids);
		} else if (this.id === "reject-advertisements") {
			$(REASON_REJECT_MODAL).modal('show');
			$(REASON_REJECT).focus();
		}
	});

	function approveSelectedAdvertisements(advertisements_ids) {
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_APPROVE_ADVERTISEMENTS,
			method: 'POST',
			dataType: 'json',
			data: { advertisements_ids: advertisements_ids },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	}

	// O motivo e OPCIONAL: o envio acontece com o campo vazio, igual a fila de clinicas.
	$(document).on('click', SEND_REJECT_REASON, function() {
		let advertisements_ids = selectedAdvertisementIds();
		if (advertisements_ids === "") { return; }
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_REJECT_ADVERTISEMENTS,
			method: 'POST',
			dataType: 'json',
			data: { advertisements_ids: advertisements_ids, reject_reason: $(REASON_REJECT).val() },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	});

});
